// extracted by mini-css-extract-plugin
export var logo = "_gm-2";
export var logoWrapper = "_gm-1";
export var strip = "_gm-0";